import { Helmet } from 'react-helmet-async';

export default function PageHead({
  title = 'Title',
  description = 'meta_description'
}) {
  return (
    <Helmet>
      <title>{title} | HSDesk</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}
